import { logger } from '@modules/logger';
import { createContext } from 'react';

interface ProgressChecklistStep {
  id: string;
  name: string;
  active: boolean;
  completed: boolean;
}

type ProgressChecklistAction =
  | { type: 'SHOW' }
  | { type: 'FINISH' }
  | { type: 'INITIALIZE_CHECKLIST'; value: ProgressChecklistStep[] }
  | { type: 'ADD_STEPS'; value: ProgressChecklistStep[]; overwrite?: boolean }
  | { type: 'COMPLETE_CURRENT_STEP'; advance?: boolean }
  | { type: 'COMPLETE_STEP'; value: string; advance?: boolean; completePreviousSteps?: boolean | string[] }
  | { type: 'MAKE_STEP_ACTIVE'; value: string; completePreviousSteps?: boolean | string[] }
  | { type: 'MOVE_TO_PREV_STEP' };
//| { type: "GO_TO_STEP"; value: string };

interface ProgressChecklistContextValues {
  show: boolean;
  steps: ProgressChecklistStep[];
  dispatch: (action: ProgressChecklistAction) => void;
}

const ProgressChecklistContext = createContext<ProgressChecklistContextValues>({
  show: false,
  steps: [],
  dispatch: () => logger.warn('dispatch not provided for ProgressChecklistContext'),
});

export { ProgressChecklistContext };
export type { ProgressChecklistStep, ProgressChecklistAction };
